import { SimpleObject } from '@/types';

const tokens: SimpleObject = {};

let i = 0;
const getToken = () => `delay_token_${i++}`;

export const CmdToken = {
  source() {
    const token = getToken()
    const cancel = () => {
      clearTimeout(tokens[token]?.timer);
      delete tokens[token];
    }
    const execute = () => {
      const t = tokens[token];
      if (t) {
        clearTimeout(t.timer);
        return t.fn();
      }
    }
    return { token, cancel, execute };
  }
};

export const delayExec = <T = any>(fn: () => Promise<T>, timeout: number, cmdToken: string) => {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      fn().then(resolve).catch(reject);
    }, timeout);
    if (cmdToken) {
      tokens[cmdToken] = { timer, fn };
    }
  });
};
